import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule as SharedComponentsModule } from 'src/app/shared/components/components.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { CustomerCreateEditModalModule } from '../../customers/customer-create-edit-modal/customer-create-edit-modal.module';
import { ModernOverviewComponent } from './modern-overview.component';

@NgModule({
  declarations: [ModernOverviewComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgbTooltipModule,
    SharedComponentsModule,
    PipesModule,
    CustomerCreateEditModalModule
  ],
  exports: [ModernOverviewComponent]
})
export class ModernOverviewModule { }
